import * as stylex from "@stylexjs/stylex";
import { forwardRef } from "react";

import type {
  HallowElement,
  HallowElementProps,
  WithAsChild,
  WithStylexArray,
} from "../../../../types";
import { determineElementFromAsChild } from "../../../../utils";

const hallowElement: HallowElement = "li";

const styles = stylex.create({
  base: {},
});

export type ListItemProps = WithAsChild<
  WithStylexArray<HallowElementProps<typeof hallowElement>>
>;

export const ListItem = forwardRef<any, ListItemProps>(
  ({ asChild = false, children, styleXArray, ...props }, ref) => {
    const DeterminedElement = determineElementFromAsChild({
      asChild,
      hallowElement,
    });

    return (
      <DeterminedElement
        ref={ref}
        {...props}
        {...stylex.props(styles.base, styleXArray)}
      >
        {children}
      </DeterminedElement>
    );
  },
);

ListItem.displayName = "ListItem";
